import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Allegato, AllegatoArchivio } from '../_interfaces/allegato';

@Injectable({
  providedIn: 'root'
})
export class AllegatiService {

  private baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getAllegati(tabella: string, tipo: string, id: string): Observable<{ data: Allegato[] }> {
    return this.http.get(`${this.baseUrl}/allegati/get/${tabella}/${tipo}/${id}`).pipe(
      map((res: { data: Allegato[] }) => res));
  }

  getAllegatiArchivio(idUtente: string): Observable<{ data: AllegatoArchivio[] }> {
    return this.http.get(`${this.baseUrl}/archivio/get/${idUtente}`).pipe(
      map((res: { data: AllegatoArchivio[] }) => res));
  }


  addAllegato(allegato: Allegato): Observable<{ res: string, message: string }> {
    return this.http.post(`${this.baseUrl}/allegati/add`, allegato).pipe(
      map((res: { res: string, message: string }) => res));
  }

  addAllegatoArchivio(allegato: AllegatoArchivio): Observable<{ res: string, message: string }> {
    return this.http.post(`${this.baseUrl}/archivio/add`, allegato).pipe(
      map((res: { res: string, message: string }) => res));
  }

  delAllegatoArchivio(allegato: { arc_id: number }): Observable<{ res: string, message: string }> {
    return this.http.post(`${this.baseUrl}/archivio/del`, allegato).pipe(
      map((res:{ res: string, message: string }) => res));
  }

}
